import React, { useState, useRef, useEffect } from 'react';
import '../styles/faq.css';

const faqData = [
    { question: "How many hours of sleep do I need each night?", answer: "Most adults need 7-9 hours of sleep per night, but individual needs may vary." },
    { question: "What are some tips for falling asleep faster?", answer: "Establish a bedtime routine, limit screen time before bed, and create a relaxing sleep environment." },
    { question: "How does diet affect sleep quality?", answer: "Eating a balanced diet and avoiding caffeine and heavy meals before bedtime can improve sleep quality." },
    { question: "What is REM sleep, and why is it important?", answer: "REM sleep is a deep sleep stage crucial for memory, learning, and mood regulation." },
    { question: "Can exercise help improve sleep?", answer: "Yes, regular physical activity promotes better sleep, though intense exercise close to bedtime may be counterproductive." },
    { question: "How can I reduce stress to sleep better?", answer: "Try relaxation techniques like deep breathing, meditation, or journaling before bed to reduce stress." },
    { question: "What is the best sleep position?", answer: "Sleeping on your back or side is generally considered best for spine alignment and overall health." },
    { question: "Are naps beneficial for sleep?", answer: "Short naps (20-30 minutes) can boost alertness and mood, but longer naps may interfere with nighttime sleep." },
    { question: "What are natural remedies for better sleep?", answer: "Herbal teas, such as chamomile or valerian root, and aromatherapy may aid relaxation and sleep." },
    { question: "How does blue light from screens affect sleep?", answer: "Blue light suppresses melatonin production, making it harder to fall asleep. Limit screen time before bed." },
    { question: "Is it bad to sleep with the TV on?", answer: "Sleeping with the TV on can disrupt sleep quality due to light and sound; try setting a timer if necessary." },
    { question: "How can I create a better sleep environment?", answer: "Keep your room cool, dark, and quiet, and invest in comfortable bedding for a restful sleep environment." },
    { question: "Why do I wake up during the night?", answer: "Waking up can be due to stress, diet, sleep disorders, or an uncomfortable sleep environment." },
    { question: "What are the effects of caffeine on sleep?", answer: "Caffeine is a stimulant that can disrupt sleep; try to avoid it at least 6 hours before bedtime." },
    { question: "How can I manage insomnia?", answer: "Maintain a regular sleep schedule, avoid naps, and consider cognitive behavioral therapy if insomnia persists." }
];

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const faqRef = useRef();

    useEffect(() => {
        const currentRef = faqRef.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    currentRef.classList.add("fade-in");
                }
            },
            { threshold: 0.1 }
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section" ref={faqRef}>
            <h2 className="faq-title">Frequently Asked Questions about Sleep</h2>
            <div className="faq-container">
                {faqData.map((item, index) => (
                    <div
                        className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                        key={index}
                        onClick={() => toggleAccordion(index)}
                    >
                        <div className="faq-question">{item.question}</div>
                        <div className="faq-answer">
                            <p>{item.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FAQ;
